import React, { Fragment } from "react";
import { TextField, FormHelperText } from "@material-ui/core";
import NumberFormat from "react-number-format";
import { connect } from "formik";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  labelRoot: {
    fontSize: "17px"
  },
  inputField: {
    borderBottom: "1px solid #2196F3"
  },
  error: {
    borderBottom: "1px solid red"
  }
});

const ThreeDecimal = props => {
  const { inputRef, value, onChange, ...other } = props;

  return (
    <NumberFormat
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      decimalScale={3}
      thousandSeparator
      allowNegative
      value={value}
      {...other}
    />
  );
};

const TwoDecimal = props => {
  const { inputRef, value, onChange, ...other } = props;

  return (
    <NumberFormat
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      decimalScale={2}
      thousandSeparator
      allowNegative
      value={value}
      {...other}
    />
  );
};

const DecimalNumberFormat = props => {
  const { inputRef, value, onChange, ...other } = props;

  return (
    <NumberFormat
      isNumericString
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      allowNegative
      value={value}
      {...other}
    />
  );
};

const DecimalInput = ({ label, calculateLabel, fieldName, formik, classes, decimalScale, ...other }) => {
  const { values, handleChange, errors } = formik;

  if (typeof calculateLabel === "function") {
    label = calculateLabel(formik, fieldName);
  }
  let numberFormat = DecimalNumberFormat;
  if (decimalScale === 2) {
    numberFormat = TwoDecimal;
  } else if (decimalScale === 3) {
    numberFormat = ThreeDecimal;
  }
  const inputLabelProps = {
    FormLabelClasses: {
      root: classes.labelRoot
    }

  };

  const hasError = Boolean(errors[fieldName]);

  let inputFieldClass = classes.inputField;
  if (hasError) {
    inputFieldClass = classes.error;
  }

  return (
    <>
      <TextField
        type="text"
        label={label || (<div />)}
        name={fieldName}
        value={values[fieldName]}
        onChange={handleChange}
        InputLabelProps={inputLabelProps}
        InputProps={{
          classes: {
            input: inputFieldClass
          },
          disableUnderline: true,
          inputComponent: numberFormat,
          inputProps: { allowNegative: other.allowNegative }
        }}
        error={hasError}
        {...other}
      />
      {hasError && <FormHelperText error={hasError}>{errors[fieldName]}</FormHelperText>}
    </>
  );
};
export default compose(
  withStyles(styles),
  connect
)(DecimalInput);
